import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import RegularButton from "segments/desktop/core-components/button/regular-button/regular-button";
import TemplateHeader from "template-store/components/template-header/template-header";
import TemplateBenefits from "template-store/components/template-benefits/template-benefits";
import TemplateLongDescription from "template-store/components/template-long-description/template-long-description";
import { getPlatformAddSolutionLink } from "/constants/links";
import { withGenericConfig } from "/contexts/generic-config-context";
import { getCategoriesData } from "template-store/services/solution-categories-service";
import { SIGN_UP_WITH_TEMPLATE_CLICKED } from "constants/bigbrain-event-types";
import { trackEvent } from "services/bigbrain-service";
import { getSolutionEnglishName } from "template-store/services/solution-data-service";
import { getSolutionsHomeLink } from "template-store/services/solution-links-service";
import ArrowLeft from "static/svg/arrow-left.svg";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import PictureComponent from "/components/core/picture/picture-component";
import { StyledMobileTemplatePageContent } from "./mobile-template-page-content.scss";
const MobileTemplatePageContent = (props)=>{
    const { template, templateId, translate, allCategories } = props;
    const templateData = template === null || template === void 0 ? void 0 : template.data;
    const onUseTemplateClickAction = useCallback(()=>{
        trackEvent(SIGN_UP_WITH_TEMPLATE_CLICKED, {
            kind: templateId,
            info1: getSolutionEnglishName(template)
        });
    }, [
        template,
        templateId
    ]);
    const assets = templateData === null || templateData === void 0 ? void 0 : templateData.images;
    const assetRenderer = (imageData)=>/*#__PURE__*/ _jsx("div", {
            className: "template-image-wrapper",
            children: /*#__PURE__*/ _jsx(PictureComponent, {
                className: "template-image",
                src: imageData === null || imageData === void 0 ? void 0 : imageData.url,
                alt: imageData === null || imageData === void 0 ? void 0 : imageData.title
            })
        });
    return /*#__PURE__*/ _jsxs(StyledMobileTemplatePageContent, {
        className: "mobile-template-page-content-component",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "template-center-link-wrapper",
                children: [
                    /*#__PURE__*/ _jsx(ArrowLeft, {
                        className: "arrow-left"
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        href: getSolutionsHomeLink(),
                        className: "template-center-link",
                        children: translate("templateCenter.template.templateCenterName")
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "template-top-section-wrapper",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "header-wrapper",
                    children: /*#__PURE__*/ _jsx(TemplateHeader, {
                        templateName: templateData === null || templateData === void 0 ? void 0 : templateData.name,
                        templateCategoriesData: getCategoriesData(allCategories, templateData === null || templateData === void 0 ? void 0 : templateData.categories),
                        categoriesPrefixText: translate("templateCenter.category.idealFor")
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "assets-carousel-wrapper",
                children: /*#__PURE__*/ _jsx(Carousel, {
                    items: assets,
                    itemRenderer: assetRenderer,
                    slidesToShow: 1,
                    centerPadding: "16px",
                    autoplay: false,
                    dots: true,
                    carouselClassName: "template-page-carousel",
                    defaultIndex: 0
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "template-description-wrapper",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "template-description",
                    children: [
                        " ",
                        templateData === null || templateData === void 0 ? void 0 : templateData.description
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "button-wrapper",
                children: /*#__PURE__*/ _jsx(RegularButton, {
                    buttonText: translate("templateCenter.template.useTemplate"),
                    url: getPlatformAddSolutionLink(templateId),
                    isOpenLinkInNewTab: true,
                    onClick: onUseTemplateClickAction,
                    buttonSize: "full"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "benefits-wrapper",
                children: /*#__PURE__*/ _jsx(TemplateBenefits, {
                    benefits: templateData === null || templateData === void 0 ? void 0 : templateData.benefits
                })
            }),
            (templateData === null || templateData === void 0 ? void 0 : templateData.longDescription) && /*#__PURE__*/ _jsxs("div", {
                className: "long-description-wrapper",
                children: [
                    /*#__PURE__*/ _jsx("hr", {
                        className: "template-long-description-divider"
                    }),
                    /*#__PURE__*/ _jsx(TemplateLongDescription, {
                        descriptions: templateData.longDescription
                    })
                ]
            })
        ]
    });
};
MobileTemplatePageContent.defaultProps = {};
export default withGenericConfig(MobileTemplatePageContent);
